module.exports = "<svg style=\"width: 16px; height: 16px\" viewBox=\"0 0 16 16\"><path d=\"M8,16 C12.418,16 16,12.418 16,8 C16,3.582 12.418,0 8,0 C3.582,0 0,3.582 0,8 C0,12.418 3.582,16 8,16 L8,16 Z M8,14 C11.313,14 14,11.313 14,8 C14,4.687 11.313,2 8,2 C4.687,2 2,4.687 2,8 C2,11.313 4.687,14 8,14 L8,14 Z M4,9 L12,9 L12,7 L4,7 L4,9 Z\" id=\"Page-1\" stroke=\"none\" fill=\"#000000\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./assets/icons/minus-circle.svg
// module id = 264
// module chunks = 0